import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  appId: string = ""

  private userProfileSubject = new BehaviorSubject<any>(null);
  userProfile$ = this.userProfileSubject.asObservable();

  setUserProfile(v: any) {
    this.userProfileSubject.next(v);
  }

  get userProfile() {
    return this.userProfileSubject.value;
  }
}
